import authHeader from '@/helpers/auth-header';
import axios from '@/helpers/http-common';
import {User} from '@/stores/authentication/types';


const login = (email: string, password: string) => {
  const body = {
    email,
    password,
  };
  return axios.post(`/login`, body);
};

const logout = () => {
  localStorage.removeItem('jwt');
};

const getUser = () => {
  return axios.get(`/current`);
};

const updatePassword = (data: object) => {
  return axios.put(`/password`, { user: data });
};

const create = (user: User) => {
  return axios.post(`/users`, { user });
};

const update = (user: User) => {
  return axios.put(`/admin/users/${user.id}`, { user });
};

const index = (
    page: number = 1,
    perPage: number = 10,
    search: string = '',
    archived: boolean = false,
    hide: boolean = false,
) => {
  return axios.get(`/users?page=${page}&per_page=${perPage}&search=${search}&archived=${archived}&hide=${hide}`);
};

const select = (search: string = '', limit: number = 10) => {
  return axios.get(`/users?search=${search}&limit=${limit}`);
};

export const userService = {
  login,
  logout,
  getUser,
  index,
  select,
  create,
  update,
  updatePassword,
};
